import { normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "d-flex justify-space-between align-start pb-2" };
const _hoisted_2 = { class: "d-flex justify-space-between" };
const _hoisted_3 = { class: "grey lighten-5 px-4 py-4" };
const _hoisted_4 = { class: "require-field-wrapper pb-4" };
const _hoisted_5 = { class: "d-flex justify-space-between" };
const _hoisted_6 = { class: "pay-difference" };
const _hoisted_7 = { class: "d-flex justify-end align-center checkbox-wrapper" };
const _hoisted_8 = { class: "body2-text" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DialogHeader = _resolveComponent("DialogHeader");
    const _component_v_card_title = _resolveComponent("v-card-title");
    const _component_PayTypeWithAmount = _resolveComponent("PayTypeWithAmount");
    const _component_v_divider = _resolveComponent("v-divider");
    const _component_v_card = _resolveComponent("v-card");
    const _component_v_text_field = _resolveComponent("v-text-field");
    const _component_v_form = _resolveComponent("v-form");
    const _component_v_checkbox = _resolveComponent("v-checkbox");
    const _component_DialogFooter = _resolveComponent("DialogFooter");
    const _component_v_card_text = _resolveComponent("v-card-text");
    const _component_v_dialog = _resolveComponent("v-dialog");
    return (_openBlock(), _createBlock(_component_v_dialog, {
        modelValue: _ctx.dialog,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.dialog) = $event)),
        "content-class": "responsive-dialog",
        "onClick:outside": _ctx.handleClickCancelAdjustPayment,
        onKeydown: _withKeys(_ctx.handleClickCancelAdjustPayment, ["esc"])
    }, {
        activator: _withCtx(({ props }) => [
            _renderSlot(_ctx.$slots, "activator", _normalizeProps(_guardReactiveProps(props)), undefined, true)
        ]),
        default: _withCtx(() => [
            _createVNode(_component_v_card, {
                flat: "",
                tile: "",
                class: "overflow-x-hidden"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_DialogHeader, {
                        title: _ctx.$t(`${_ctx.lc}adjust_payment_information`),
                        "on-cancel": _ctx.handleClickCancelAdjustPayment
                    }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                    _createVNode(_component_v_card, {
                        flat: "",
                        tile: "",
                        class: "grey lighten-4"
                    }, {
                        default: _withCtx(() => [
                            _createCommentVNode(" 변경 전 "),
                            _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-2" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}before_change`)), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createCommentVNode(" 결제방법 "),
                            _createElementVNode("div", _hoisted_1, [
                                _createVNode(_component_v_card_title, { class: "body2-text brg-color-grey-600 py-0" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}payment_type`)), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_card_title, { class: "body2-text text-black py-0" }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_PayTypeWithAmount, {
                                            "pay-types": _ctx.order.payTypes,
                                            "align-class": "justify-end",
                                            "is-full-text": ""
                                        }, null, 8 /* PROPS */, ["pay-types"])
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _createCommentVNode("총 결제금액 "),
                            _createElementVNode("div", _hoisted_2, [
                                _createVNode(_component_v_card_title, { class: "body2-text brg-color-grey-600 pt-0" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}total_amount`)), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_card_title, { class: "body2-text text-black pt-0" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.orderAmount), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _createVNode(_component_v_divider)
                        ]),
                        _: 1 /* STABLE */
                    }),
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createCommentVNode(" 변경 후 "),
                            _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-0" }, {
                                default: _withCtx(() => [
                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}after_change`)), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_v_form, { ref: "form" }, {
                                default: _withCtx(() => [
                                    _createCommentVNode(" 현금 금액 "),
                                    _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-2" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}cash`)), 1 /* TEXT */),
                                            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-red" }, "*", -1 /* CACHED */))
                                        ]),
                                        _: 1 /* STABLE */,
                                        __: [9]
                                    }),
                                    _createVNode(_component_v_text_field, {
                                        modelValue: _ctx.formattedCashAmountComputed,
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.formattedCashAmountComputed) = $event)),
                                        suffix: _ctx.$t('common.currency'),
                                        label: _ctx.$t(`${_ctx.lc}amount_required`),
                                        "single-line": "",
                                        dense: "",
                                        variant: "outlined",
                                        "validate-on": "blur",
                                        "hide-details": "auto",
                                        inputmode: "numeric",
                                        oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                                        class: "text-field",
                                        onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.handleBlurCashAmount(_ctx.formattedCashAmountComputed))),
                                        onKeyup: _ctx.checkAmount
                                    }, null, 8 /* PROPS */, ["modelValue", "suffix", "label", "onKeyup"]),
                                    _createCommentVNode(" 카드 금액 "),
                                    _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-2" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}card`)), 1 /* TEXT */),
                                            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-red" }, "*", -1 /* CACHED */))
                                        ]),
                                        _: 1 /* STABLE */,
                                        __: [10]
                                    }),
                                    _createVNode(_component_v_text_field, {
                                        modelValue: _ctx.formattedCardAmountComputed,
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.formattedCardAmountComputed) = $event)),
                                        suffix: _ctx.$t('common.currency'),
                                        label: _ctx.$t(`${_ctx.lc}amount_required`),
                                        "single-line": "",
                                        dense: "",
                                        variant: "outlined",
                                        "validate-on": "blur",
                                        "hide-details": "auto",
                                        inputmode: "numeric",
                                        oninput: "javascript: this.value = this.value.replace(/[^0-9]/g, '' );",
                                        class: "text-field",
                                        onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.handleBlurCardAmount(_ctx.formattedCardAmountComputed))),
                                        onKeyup: _ctx.checkAmount
                                    }, null, 8 /* PROPS */, ["modelValue", "suffix", "label", "onKeyup"]),
                                    _createCommentVNode(" 선결제 금액  "),
                                    _createVNode(_component_v_card_title, { class: "text-subtitle-2 brg-color-grey-600 pb-2" }, {
                                        default: _withCtx(() => [
                                            _createElementVNode("span", null, _toDisplayString(_ctx.$t(`${_ctx.lc}prepay`)), 1 /* TEXT */),
                                            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-red" }, "*", -1 /* CACHED */))
                                        ]),
                                        _: 1 /* STABLE */,
                                        __: [11]
                                    }),
                                    _createVNode(_component_v_text_field, {
                                        modelValue: _ctx.formattedPrePayAmountComputed,
                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.formattedPrePayAmountComputed) = $event)),
                                        suffix: _ctx.$t('common.currency'),
                                        label: _ctx.$t(`${_ctx.lc}amount_required`),
                                        "single-line": "",
                                        dense: "",
                                        variant: "outlined",
                                        "validate-on": "blur",
                                        "hide-details": "",
                                        inputmode: "numeric",
                                        class: "text-field",
                                        filled: "",
                                        disabled: "",
                                        onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.handleBlurPrePayAmount(_ctx.formattedPrePayAmountComputed)))
                                    }, null, 8 /* PROPS */, ["modelValue", "suffix", "label"])
                                ]),
                                _: 1 /* STABLE */
                            }, 512 /* NEED_PATCH */),
                            _createCommentVNode("총 결제금액 "),
                            _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_v_card_title, { class: "body2-text brg-color-grey-600" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}total_amount`)), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createVNode(_component_v_card_title, { class: "body2-text text-black" }, {
                                    default: _withCtx(() => [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.changedTotalAmount), 1 /* TEXT */),
                                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.difference), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _createCommentVNode(" 비대면 여부 체크 "),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t(`${_ctx.lc}is_untact`)), 1 /* TEXT */),
                                _createVNode(_component_v_checkbox, {
                                    modelValue: _ctx.untact,
                                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.untact) = $event)),
                                    density: "compact",
                                    "hide-details": "",
                                    "input-value": "true",
                                    disabled: _ctx.isUntactDisabled,
                                    class: "pa-0 ma-0 checkbox"
                                }, null, 8 /* PROPS */, ["modelValue", "disabled"])
                            ])
                        ])
                    ]),
                    _createVNode(_component_v_divider),
                    _createVNode(_component_DialogFooter, {
                        cancel: true,
                        ok: true,
                        "on-cancel": _ctx.handleClickCancelAdjustPayment,
                        "on-ok": _ctx.handleClickAdjustPayment
                    }, null, 8 /* PROPS */, ["on-cancel", "on-ok"])
                ]),
                _: 1 /* STABLE */
            }),
            _createCommentVNode(" 확인 알림창 "),
            _createVNode(_component_v_dialog, {
                modelValue: _ctx.confirmDialog,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.confirmDialog) = $event)),
                persistent: "",
                "content-class": "responsive-dialog"
            }, {
                default: _withCtx(() => [
                    _createVNode(_component_v_card, {
                        flat: "",
                        tile: ""
                    }, {
                        default: _withCtx(() => [
                            _createVNode(_component_DialogHeader, {
                                title: _ctx.$t(`${_ctx.lc}confirm_payment_information`),
                                "on-cancel": _ctx.handleClickConfirmCancel
                            }, null, 8 /* PROPS */, ["title", "on-cancel"]),
                            _createVNode(_component_v_card_text, { class: "body2-text brg-color-grey-600 pa-4" }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t(`${_ctx.lc}confirm_payment_information_description`, { changedOrderAmount: _ctx.changedOrderAmount })), 1 /* TEXT */)
                                ]),
                                _: 1 /* STABLE */
                            }),
                            _createVNode(_component_DialogFooter, {
                                cancel: true,
                                ok: true,
                                "on-cancel": _ctx.handleClickConfirmCancel,
                                "on-ok": _ctx.handleClickConfirmOk
                            }, null, 8 /* PROPS */, ["on-cancel", "on-ok"])
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                _: 1 /* STABLE */
            }, 8 /* PROPS */, ["modelValue"])
        ]),
        _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["modelValue", "onClick:outside", "onKeydown"]));
}
